import { render, staticRenderFns } from "./CreateupdateUser.vue?vue&type=template&id=00d8f4b1&scoped=true&"
import script from "./CreateupdateUser.vue?vue&type=script&lang=js&"
export * from "./CreateupdateUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateupdateUser.vue?vue&type=style&index=0&id=00d8f4b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8f4b1",
  null
  
)

export default component.exports